import React from "react";

//dls
import { SpriteIconWeb } from "@swiggy-private/dls-web-icons/dist/SpriteIconWeb";

export const CROUTON_CLOSE_ICON = <SpriteIconWeb iconName="close12" fillColor="text_inverse_Low_Emphasis" />;

export const CLOSE_ICON_CSS_PROPERTIES: React.CSSProperties = {
    background: "none",
    display: "flex",
    alignItems: "center",
    marginLeft: 12,
    marginRight: 12,
};
